import React, { useMemo, useState, useEffect } from 'react';
import { useGlobalState } from '../GlobalStateContext';
import WalletConnectComponent from './WalletConnectComponent';
import ApproveButton from './ApproveButton';
import { useAccount } from 'wagmi';

const TokenAuthSection = React.memo(() => {
  // All hooks must be called at the top level, before any conditional logic
  const { isConnected } = useAccount();
  const { params, authorizationStatus, isCheckingAuth } = useGlobalState();
  const [tokenSymbol, setTokenSymbol] = useState(''); // Add state for token symbol
  
  const { sender, fromTokenAddress } = params;
  const { isAuthorized, allowance, lastChecked, error } = authorizationStatus;

  // Get token symbol from localStorage historyOptions when fromTokenAddress changes
  useEffect(() => {
    if (fromTokenAddress) {
      try {
        const savedHistoryOptions = localStorage.getItem('swapHistoryOptions');
        if (savedHistoryOptions) {
          const historyOptions = JSON.parse(savedHistoryOptions);
          const fromTokenOption = historyOptions.fromTokenAddress.find(
            option => option.value.toLowerCase() === fromTokenAddress.toLowerCase()
          );
          if (fromTokenOption?.label) {
            setTokenSymbol(fromTokenOption.label);
          } else {
            setTokenSymbol('');
          }
        }
      } catch (e) {
        console.error('Failed to load token symbol from localStorage', e);
        setTokenSymbol('');
      }
    } else {
      setTokenSymbol('');
    }
  }, [fromTokenAddress]);

  // 使用 useMemo 缓存样式对象，避免每次渲染都创建新对象
  const statusStyle = useMemo(() => ({
    background: isAuthorized ? '#d4edda' : '#f8d7da', 
    color: isAuthorized ? '#155724' : '#721c24',
    padding: '10px', 
    borderRadius: '5px', 
    margin: '10px 0',
    fontSize: '14px',
    border: `1px solid ${isAuthorized ? '#c3e6cb' : '#f5c6cb'}`
  }), [isAuthorized]);

  const statusText = useMemo(() => {
    return `授权状态: ${isAuthorized ? '✅ 已授权' : '❌ 未授权'}${isCheckingAuth ? ' (检查中...)' : ''}`;
  }, [isAuthorized, isCheckingAuth]);

  

  // 如果已授权，不渲染整个组件
  if (isAuthorized) {
    return null;
  }

  // 只有当sender和fromToken都不为空时才显示内容
  if (!sender || !fromTokenAddress) {
    return (
      <div className="left-top-section">
        <h3>授权要卖出的代币</h3>
        <p style={{ color: '#666', fontSize: '14px', margin: '10px 0' }}>
          请先在下方配置币安钱包地址和刷分策略
        </p>
      </div>
    );
  }

  return (
    <div className="left-top-section">
      <h3>授权要卖出的{tokenSymbol ? ` ${tokenSymbol}` : '代币'}</h3>
      {/* 显示当前配置信息 */}
      {/* 显示授权状态 */}
      <div style={statusStyle}>
        <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>
          {statusText}
        </div>
      </div>
                
      <WalletConnectComponent>
      </WalletConnectComponent>
      <ApproveButton />

    
    </div>
  );
});

TokenAuthSection.displayName = 'TokenAuthSection';

export default TokenAuthSection; 